export const experiences = [
    {
        id: 1,
        title: "Software Engineer",
        company: "Akij IBOS Limited",
        year: "Sep 2024 – Present",
        hireFor: "React.js • Next.js • TypeScript",

        role: [
            "Develop enterprise-grade web applications using React.js, Next.js, and TypeScript.",
            "Build reusable, scalable, and maintainable UI components following modern frontend best practices.",
            "Integrate REST APIs and collaborate closely with backend engineers to deliver seamless user experiences.",
            "Optimize application performance through code splitting, lazy loading, and rendering optimizations.",
            "Contribute to frontend architecture, code reviews, and technical discussions to improve code quality and scalability.",
            "Work with cross-functional teams to deliver high-quality features aligned with business requirements."
        ],

        address: "6/2 Kazi Nazrul Islam Rd, Dhaka 1207",
    },

    {
        id: 2,
        title: "Frontend Developer",
        company: "JS Template (Contract) ",
        year: "Jul 2024 – Aug 2024",
        hireFor: "Next.js • Strapi • TurboRepo",

        role: [
            "Developed a dynamic Job Management Portal using Next.js and Strapi Headless CMS.",
            "Built reusable page components and dynamic content sections managed entirely from Strapi.",
            "Managed a TurboRepo monorepo architecture, improving development workflow and code organization.",
            "Implemented Server-Side Rendering (SSR) and dynamic routing to improve performance and SEO.",
            "Integrated REST APIs and optimized frontend performance for a responsive user experience.",
            "Collaborated with designers and backend developers to deliver production-ready features."
        ],

        address: "Remote",
    },

    {
        id: 3,
        title: "Frontend Developer",
        company: "RBS Tech LTD",
        year: "May 2022 – May 2024",
        hireFor: "React.js & Next.js",


        role: [
            "Developed enterprise ERP modules including Project Management, Task Management, Requisition, Expense, VAT, TAX, and Invoice Management.",
            "Built real-time chat functionality using WebSocket for instant communication.",
            "Implemented Kanban boards with drag-and-drop interactions and real-time updates.",
            "Integrated REST APIs and collaborated with backend teams to deliver business-critical features.",
            "Developed responsive, reusable UI components using React.js and Material UI.",
            "Worked closely with product managers and designers to deliver scalable enterprise solutions."
        ],

        address: "House No: 998, 1st Floor, Avenue:11, Road: 9/A, Mirpur DOHS",
    },
    {
        id: 4,
        title: "Frontend Developer",
        company: "Taqwah Digital",
        hireFor: "React & React Native",
        year: "NOV 2021 - APR 2022",
        role: [
            "Developed cross-platform mobile applications using React Native (Expo & Bare Workflow).",
            "Built core features for an NFT Marketplace, including wallet connection, property search, buying, selling, and bidding functionality.",
            "Developed e-commerce application features including product browsing, payment integration, and order tracking.",
            "Collaborated with the development team to debug, test, and maintain web and mobile applications, improving application stability and user experience.",

        ],
        address: "Mirpur-2, Dhaka 1216",


    },
];